<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :fill="color"
        fill-rule="evenodd"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <mask id="view" maskUnits="userSpaceOnUse" x="0" y="5" width="24" height="14">
            <path
                d="M12 18.714c1.036 0 2.08-.178 3.134-.535 1.053-.358 1.902-.697 2.545-1.018.642-.322 1.482-.911 2.517-1.768 1.036-.857 1.688-1.41 1.956-1.66s.884-.858 1.848-1.822C19.929 7.304 15.929 5 12 5c-2.071 0-4.009.563-5.813 1.688C4.385 7.813 2.321 9.535 0 11.857c1.214 1.25 2.125 2.15 2.732 2.704.607.554 1.447 1.224 2.518 2.01 1.071.785 2.143 1.339 3.214 1.66 1.072.322 2.25.482 3.536.482zm0-1.982c-1.321 0-2.464-.482-3.429-1.446-.928-.965-1.392-2.107-1.392-3.429 0-1.321.473-2.464 1.42-3.428.946-.965 2.08-1.447 3.401-1.447 1.321 0 2.455.482 3.402 1.447.946.964 1.42 2.107 1.42 3.428 0 1.322-.474 2.464-1.42 3.429-.947.964-2.08 1.446-3.402 1.446zm0-2.036c.786 0 1.446-.276 1.982-.83.536-.553.804-1.223.804-2.009v-.375c-.357.25-.715.375-1.072.375-.5 0-.91-.16-1.232-.482-.321-.321-.482-.732-.482-1.232 0-.393.143-.768.429-1.125H12c-.786 0-1.446.277-1.982.83-.536.554-.804 1.223-.804 2.01 0 .785.268 1.454.804 2.008s1.196.83 1.982.83z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#view)">
            <path
                d="M12 18.714c1.036 0 2.08-.178 3.134-.535 1.053-.358 1.902-.697 2.545-1.018.642-.322 1.482-.911 2.517-1.768 1.036-.857 1.688-1.41 1.956-1.66s.884-.858 1.848-1.822C19.929 7.304 15.929 5 12 5c-2.071 0-4.009.563-5.813 1.688C4.385 7.813 2.321 9.535 0 11.857c1.214 1.25 2.125 2.15 2.732 2.704.607.554 1.447 1.224 2.518 2.01 1.071.785 2.143 1.339 3.214 1.66 1.072.322 2.25.482 3.536.482zm0-1.982c-1.321 0-2.464-.482-3.429-1.446-.928-.965-1.392-2.107-1.392-3.429 0-1.321.473-2.464 1.42-3.428.946-.965 2.08-1.447 3.401-1.447 1.321 0 2.455.482 3.402 1.447.946.964 1.42 2.107 1.42 3.428 0 1.322-.474 2.464-1.42 3.429-.947.964-2.08 1.446-3.402 1.446zm0-2.036c.786 0 1.446-.276 1.982-.83.536-.553.804-1.223.804-2.009v-.375c-.357.25-.715.375-1.072.375-.5 0-.91-.16-1.232-.482-.321-.321-.482-.732-.482-1.232 0-.393.143-.768.429-1.125H12c-.786 0-1.446.277-1.982.83-.536.554-.804 1.223-.804 2.01 0 .785.268 1.454.804 2.008s1.196.83 1.982.83z"
            />
            <path d="M36.571-13.286H-12.19v48.762H36.57v-48.762z" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'ViewSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
